import { render, staticRenderFns } from "./DownloadPanel.vue?vue&type=template&id=06d1fa08&scoped=true&lang=pug&"
import script from "./DownloadPanel.vue?vue&type=script&lang=js&"
export * from "./DownloadPanel.vue?vue&type=script&lang=js&"
import style0 from "./DownloadPanel.vue?vue&type=style&index=0&id=06d1fa08&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d1fa08",
  null
  
)

export default component.exports